//#region src/simphony_information_line_field.ts
var SimphonyInformationLineField = /* @__PURE__ */ function(SimphonyInformationLineField) {
	SimphonyInformationLineField["GuestName"] = "guest-name";
	SimphonyInformationLineField["GuestPhoneNumber"] = "guest-phone-number";
	SimphonyInformationLineField["GuestEmail"] = "guest-email";
	SimphonyInformationLineField["OutpostName"] = "outpost-name";
	SimphonyInformationLineField["TableNumber"] = "table-number";
	return SimphonyInformationLineField;
}(SimphonyInformationLineField || {});
//#endregion
export { SimphonyInformationLineField };

//# sourceMappingURL=simphony_information_line_field.js.map